import { useRecordContext } from "ra-core";
import { cn } from "@/lib/utils";

const HR_STATUS_CONFIG: Record<string, { label: string; classes: string }> = {
  active: { label: "Active", classes: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  inactive: { label: "Inactive", classes: "bg-muted text-muted-foreground border-input" },
  terminated: { label: "Terminated", classes: "bg-red-100 text-red-700 border-red-300" },
  on_leave: { label: "On Leave", classes: "bg-amber-100 text-amber-700 border-amber-300" },
  present: { label: "Present", classes: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  absent: { label: "Absent", classes: "bg-red-100 text-red-700 border-red-300" },
  half_day: { label: "Half Day", classes: "bg-amber-100 text-amber-700 border-amber-300" },
  leave: { label: "Leave", classes: "bg-sky-100 text-sky-700 border-sky-300" },
  holiday: { label: "Holiday", classes: "bg-purple-100 text-purple-700 border-purple-300" },
  weekoff: { label: "Week Off", classes: "bg-muted text-muted-foreground border-input" },
  pending: { label: "Pending", classes: "bg-amber-100 text-amber-700 border-amber-300" },
  approved: { label: "Approved", classes: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  rejected: { label: "Rejected", classes: "bg-red-100 text-red-700 border-red-300" },
  cancelled: { label: "Cancelled", classes: "bg-muted text-muted-foreground border-input" },
  draft: { label: "Draft", classes: "bg-muted text-muted-foreground border-input" },
  processing: { label: "Processing", classes: "bg-sky-100 text-sky-700 border-sky-300" },
  paid: { label: "Paid", classes: "bg-emerald-100 text-emerald-700 border-emerald-300" },
};

interface HRStatusBadgeProps {
  status: string;
  className?: string;
}

export const HRStatusBadge = ({ status, className }: HRStatusBadgeProps) => {
  const config = HR_STATUS_CONFIG[status] ?? {
    label: status.replaceAll("_", " "),
    classes: "bg-muted text-muted-foreground border-input",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border capitalize",
        config.classes,
        className
      )}
    >
      {config.label}
    </span>
  );
};

/** Drop-in replacement for TextField showing an HR status badge when used inside react-admin Show/List */
export const HRStatusBadgeField = ({ source = "status" }: { record?: any; source?: string }) => {
  const record = useRecordContext();
  const value = record?.[source];
  if (!value) return null;
  return <HRStatusBadge status={String(value)} />;
};
